import React, { Component } from 'react'
import './About.css';

export default class About extends Component {
    render() {
        return (
            <div className="about" id="about" name="about">
                <div className="pic">
                    <img src='../images/IMG_7824.jpg' alt=''/>
                </div>
                <div className="meText">
                    <h1>About Me</h1>
                    <p>Hey! I'm Sameer and I'm a University of Toronto computer science graduate.
                        I've had a passion for technology for the longest time and love learning about new things.
                    </p>
                    <p>
                    I'm an aspiring software engineer with experience in Python, C#, Java and many more languages. I 
                    have experience with both backend and frontend development. I have worked previous internships
                    in software development.</p>
                    <p>
                        I love learning and working on different projects. I am currently working on
                        building a Unity game that I intend on releasing on Steam. I also am building full-stack web
                        applications. Outside of working, I love playing video games, watching Formula 1 Racing, and
                        reading.
                    </p>
                </div>
            </div>
        )
    }
}

/*
I'm very passionate about machine learning as I believe it will bring significant advancements to civilization.
                    I've worked on projects in the space and even have worked an internship to apply the technology. I also love 
                    game development and software development and work on projects in my free time.
                    My hobbies include playing video games, learning about technology, and watching Formula 1 Racing.

                        My ultimate goal is to build my own startup company that solves a meaningul problem so that I can
    impact millions or even billions of people. I have fun learning about business and how to run companies along
    side learning software development. I believe pairing technology and business has become essential and I strive
    to build a company that can pair those two elements with something in biology so that I can achieve my dream
    of changing lives.
*/
